import React from 'react'
import { Link } from 'gatsby'
import Layout from "../components/layout"
 
 

const  GISDashboard = () => {
  
    
    return (
        <Layout>
      
            <div className="mt-12">
                <nav className="flex text-sm bg-gray-800 text-white overflow-hidden whitespace-nowrap border py-3 px-5 border-gray-700 hidden lg:block" aria-label="Breadcrumb">
                    <ol className="inline-flex items-center space-x-1 md:space-x-3">
                        <li className="inline-flex items-center">
                            <Link to="/" className="text-white inline-flex items-center">
                                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                                Home
                            </Link>
                        </li>
                        <li>
                            <div className="flex items-center">
                                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
                                <a href={void (0)} className="text-white ml-1 md:ml-2 font-medium">Knowledge Portal</a>
                            </div>
                        </li>
                        <li aria-current="page">
                            <div className="flex items-center">
                                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
                                <span className="text-white ml-1 md:ml-2 font-medium">GIS Dashboard</span>
                            </div>
                        </li>
                    </ol>
                </nav>
                <div className="mt-8 text-center mx-4 rounded-lg shadow-md flex justify-center">
<iframe
  id=""
  title=" "
  width="95%"
  height={1000}
  src="https://meghalayacmdashboard.in/gisportal/apps/webappviewer/index.html?id=900ca7f329244ce6bbe2c904334a8fc3">
</iframe>
            </div>
            </div>
        </Layout>
    )
}

export default GISDashboard